import { render } from "./TagIndex.vue?vue&type=template&id=11e00196"
import script from "./TagIndex.vue?vue&type=script&lang=js"
export * from "./TagIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__